import React from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import KenUploadButton from './Components/KenUploadButton';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  card: {
    margin: 16,
  },
  cardContainer: {
    padding: 8,
  },
  rowWrap: {
    marginBottom: 30,
  },
  rowWrapConditional: {
    borderBottom: 0,
  },
  rowLabel: {
    fontWeight: 500,
    color: '#091E42',
  },
  rowDesc: {
    maxWidth: '400px',
    color: '#7A869A',
  },
  mainContent: {
    position: 'relative',
  },
}));

export default function KenDocumentUpload(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { value = [], label,  description, onChange, length, index, handlePreview, required, recordId, handleDownload, fileType } = props;

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    multiple: false,
    noKeyboard: true,
    maxSize: 2000000,
    accept: label === 'Cheque' || label.toLowerCase().includes('photo') || label.toLowerCase().includes('passport') ? ['image/jpeg', 'image/png'] : ['application/pdf'],
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        enqueueSnackbar(fileRejections[0]?.errors[0]?.message.replace('2000000 bytes', '2 MB'), {
          variant: 'error',
        });
      } else {
        const acceptPdfFiles = acceptedFiles[0]?.type === 'application/pdf' || acceptedFiles[0]?.type === 'image/jpeg' || (acceptedFiles[0]?.type === 'image/png' && (!label.toLowerCase().includes('photo') || !label.toLowerCase().includes('passport') || label !== 'Cheque'));
        const acceptedImagesFiles = (acceptedFiles[0]?.type === 'image/jpeg' || acceptedFiles[0]?.type === 'image/png') && (label === 'Passport Size Photo' || label.toLowerCase().includes('photo') || label.toLowerCase().includes('passport') || label === 'Cheque');
        if (acceptPdfFiles) {
          onChange([...value, ...acceptedFiles]);
        } else if (acceptedImagesFiles) {
          onChange([...value, ...acceptedFiles]);
        } else {
          enqueueSnackbar('Only the mentioned file formats are accepted', {
            variant: 'error',
          });
        }
      }
    },
  });

  const classes = useStyles();

  return (
    <div
      className={clsx(classes.rowWrap, {
        [classes.rowWrapConditional]: length === index,
      })}
    >
      <Grid container {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <Grid xs={12} md={7}>
          <Typography align="left" className={classes.rowLabel} variant="h5">
            {label}
            {required === true && <span style={{ color: '#E75547' }}>*</span>}
          </Typography>
          <Typography align="left" className={classes.rowDesc} variant="subtitle2">
            {description}
          </Typography>
        </Grid>
        <Grid item xs={12} md={5}>
          <KenUploadButton open={open} handlePreview={handlePreview} recordId={recordId} handleDownload={handleDownload} fileType={fileType} fileName={props?.fileName} />
        </Grid>
      </Grid>
    </div>
  );
}
